// src/pages/ReceiptPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../../services/api';
import styles from './ReceiptPage.module.css';

const ReceiptPage = () => {
  const { receiptNumber } = useParams();
  const navigate = useNavigate();
  const [receipt, setReceipt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const res = await api.get(`/receipts/${receiptNumber}`);
        setReceipt(res);
      } catch (e) {
        setError(e.message || 'Не удалось загрузить квитанцию');
      } finally {
        setLoading(false);
      }
    };
    fetchReceipt();
  }, [receiptNumber]);

  if (loading) return <div className={styles.loader}>Загрузка...</div>;
  if (error)   return <div className={styles.error}>{error}</div>;
  if (!receipt) return <div className={styles.error}>Квитанция не найдена</div>;

  // Определяем цвет для статуса
  const statusClass = receipt.status === 'Закрыта'
    ? styles.statusClosed
    : styles.statusOpen;

  return (
    <div className={styles.container}>
      <button className={styles.backBtn} onClick={() => navigate(-1)}>
        ← Назад
      </button>
      <h1 className={styles.title}>Квитанция {receipt.receipt_number}</h1>

      <div className={styles.meta}>
        <p><strong>Время:</strong> {receipt.time}</p>
        <p><strong>Район:</strong> {receipt.district || '—'}</p>
        <p><strong>Организация:</strong> {receipt.organization || '—'}</p>
        <p><strong>К оплате:</strong> {receipt.to_pay}</p>
        <p><strong>Оплачено:</strong> {receipt.paid}</p>
        <p>
          <strong>Статус:</strong>{' '}
          <span className={`${styles.statusBadge} ${statusClass}`}>
            {receipt.status}
          </span>
        </p>
      </div>

      <h2 className={styles.subTitle}>Товары</h2>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Название</th>
            <th>Кол-во</th>
            <th>Цена</th>
            <th>Сумма</th>
            <th>Сканы</th>
          </tr>
        </thead>
        <tbody>
          {receipt.products.map(p => {
            const qty = p.planned_quantity ?? p.actual_quantity;
            const sum = (p.price * qty).toFixed(2);
            const scanned = Array.isArray(p.marks) ? p.marks.length : 0;
            return (
              <tr key={p.id}>
                <td>{p.product_name}</td>
                <td>{qty}</td>
                <td>{p.price}</td>
                <td>{sum}</td>
                <td>{scanned}/{qty}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ReceiptPage;
